import { InputLabel, MenuItem, Select } from '@mui/material'
import styled from 'styled-components'
import { COLORS, FONTS, TYPOGRAPHY } from 'utils'

export interface SelectStyles {
  marginTop?: string
  marginBottom?: string
  marginLeft?: string
  marginRight?: string
  width?: string
  hasError?: boolean
}

interface IInputLabelStyled {
  hasError?: boolean
}
export const InputLabelStyled = styled(InputLabel)<IInputLabelStyled>`
  font-size: ${TYPOGRAPHY.bodySize14};
  font-weight: ${FONTS.regular};
  color: ${({ hasError }) => (hasError ? COLORS.error : COLORS.black)};
  font-family: Arial;
`

export const SelectStyled = styled(Select)<SelectStyles>`
  margin-top: ${({ marginTop }) => marginTop};
  margin-bottom: ${({ marginBottom }) => marginBottom};
  margin-left: ${({ marginLeft }) => marginLeft};
  margin-right: ${({ marginRight }) => marginRight};
  width: ${({ width }) => width || '100%'};

  &.MuiInputBase-root:before {
    border-bottom: 0.1rem solid
      ${({ hasError }) => (hasError ? COLORS.error : COLORS.black)};
  }
  &.MuiInputBase-root:after {
    border-bottom: 0.1rem solid
      ${({ hasError }) => (hasError ? COLORS.error : COLORS.blueFonts)};
  }

  &.MuiInput-underline:hover:after {
    border-bottom: 0.1rem solid
      ${({ hasError }) => (hasError ? COLORS.error : COLORS.blueFonts)};
  }

  &.MuiInput-underline:hover:before {
    border-bottom: 0.1rem solid
      ${({ hasError }) => (hasError ? COLORS.error : COLORS.blueFonts)};
  }
`

export const MenuItemStyled = styled(MenuItem)`
  min-height: 2rem;
`
